import { render, staticRenderFns } from "./suporte.vue?vue&type=template&id=32838299&scoped=true&"
import script from "./suporte.vue?vue&type=script&lang=js&"
export * from "./suporte.vue?vue&type=script&lang=js&"
import style0 from "./suporte.vue?vue&type=style&index=0&id=32838299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32838299",
  null
  
)

export default component.exports